export const isAuxValueUnused = (flags: string[] = []) => {
  return flags.includes('UNUSED');
};
